import React, { useState } from "react";
import "./OrchesBenefits.css";

export default function OrchesBenefit() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Simplified Operations",
      description:
        "Reduce complexity through automated workload coordination and centralized orchestration management.",
    },
    {
      id: 2,
      title: "High Availability & Reliability",
      description:
        "Ensure continuous service availability with built-in redundancy and self-healing capabilities.",
    },
    {
      id: 3,
      title: "Scalable Application Management",
      description:
        "Scale applications dynamically to handle changing demand without performance degradation.",
    },
    {
      id: 4,
      title: "Faster Deployment Cycles",
      description:
        "Accelerate releases through automated orchestration integrated with DevOps pipelines.",
    },
    {
      id: 5,
      title: "Optimized Resource Utilization",
      description:
        "Improve efficiency and reduce infrastructure costs with intelligent resource management.",
    },
    {
      id: 6,
      title: "Future-Ready Infrastructure",
      description:
        "Build orchestration platforms designed for growth and evolving technology needs.",
    },
  ];

  return (
    <div id="orches-benefit" className="dappmainclass">
     <div className="top">
       <button className="btn">Let's Discuss Your Project</button>
          <h2 className="heading">
        Why Choose BastionEx?
      </h2>
      <p className="subheading">
      Delivering Secure, Compliant, and High-Performance CI Solutions
      </p>
     </div>

      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
